import { createStore } from "./store";

/** `expired`: the app's own session is gone (401): sign in again in place, from the login sheet. */
export const sessionStore = createStore<{ expired: boolean; reauthOpen: boolean }>({ expired: false, reauthOpen: false });

export function markSessionExpired() {
  if (typeof window === "undefined") return; // inside the service worker: the page will notice on its own
  sessionStore.set((s) => (s.expired ? s : { ...s, expired: true }));
}

export function markSessionFresh() {
  if (typeof window === "undefined") return;
  sessionStore.set({ expired: false, reauthOpen: false });
}

/** Opens the login sheet in place: nothing is lost, the outbox waits. */
export function openReauth() {
  sessionStore.set((s) => ({ ...s, reauthOpen: true }));
}
